import { DefaultSinkType } from "@core-services/data-types"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@vindral/components"

export function DefaultSinkSelection(props: {
  disabled?: boolean
  value?: DefaultSinkType | null
  onValueChange: (value: DefaultSinkType | null) => void
}) {
  const { value, onValueChange, disabled } = props

  return (
    <Select
      disabled={disabled}
      value={value ?? ""}
      onValueChange={(value: DefaultSinkType | "") => onValueChange(value == "" ? null : value)}
    >
      <SelectTrigger size="medium" data-pw="defaultSinkTypSelect">
        <SelectValue placeholder="Select a type" />
      </SelectTrigger>
      <SelectContent align="end">
        <SelectItem value={DefaultSinkType.MoQ}>MoQ</SelectItem>
        <SelectItem value={DefaultSinkType.Vindral}>Vindral</SelectItem>
        <SelectItem value={""}>Use organization default</SelectItem>
      </SelectContent>
    </Select>
  )
}
